import React from 'react';
import Icon from '../../../components/AppIcon';

const LegalInquirySection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl mb-6">
            <Icon name="MessageSquare" size={28} className="text-white" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            Haben Sie eine rechtliche Frage?
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Als eigenständige Rechtsanwaltsgesellschaft stehen wir Ihnen mit 8 Jahren
            Erfahrung zur Seite. Kontaktieren Sie uns per E-Mail und erhalten Sie binnen 24 Stunden eine
            professionelle Antwort von einem unserer Experten.
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-6 bg-white rounded-2xl shadow-sm">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Clock" size={24} className="text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">24h Antwortzeit</h3>
            <p className="text-text-secondary text-sm">
              Garantierte Rückmeldung binnen 24 Stunden, meist bereits nach wenigen Stunden
            </p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-2xl shadow-sm">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Shield" size={24} className="text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">100% Vertraulich</h3>
            <p className="text-text-secondary text-sm">
              Ihre Daten werden streng vertraulich behandelt und DSGVO-konform verarbeitet
            </p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-2xl shadow-sm">
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Award" size={24} className="text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">Expertise seit 2008</h3>
            <p className="text-text-secondary text-sm">
              8 Jahre Erfahrung und tausende erfolgreich bearbeitete Rechtsfälle
            </p>
          </div>
        </div>

        {/* Email Contact Card */}
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-2xl mb-6">
            <Icon name="Mail" size={36} className="text-white" />
          </div>
          
          <h3 className="text-3xl font-bold text-text-primary mb-4">
            Kontaktieren Sie uns per E-Mail
          </h3>
          
          <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto">
            Senden Sie uns Ihre rechtliche Frage per E-Mail. Unser Expertenteam wird sich 
            schnellstmöglich bei Ihnen melden.
          </p>
          
          <a 
            href="mailto:info@advocall.de"
            className="inline-flex items-center justify-center space-x-3 bg-gradient-to-r from-primary to-accent text-white px-8 py-4 rounded-xl font-semibold text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-200"
          >
            <Icon name="Mail" size={24} className="text-white" />
            <span>info@advocall.de</span>
          </a>
          
          <p className="text-sm text-text-secondary mt-6">
            Oder kopieren Sie die E-Mail-Adresse: <span className="font-semibold text-text-primary">info@advocall.de</span>
          </p>
        </div>

        {/* Additional Information */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-text-primary mb-4">
              Warum AdvoCall Professional wählen?
            </h3>
            <p className="text-text-secondary max-w-2xl mx-auto">
              Als ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH vereinen wir
              modernste Technologie mit bewährter juristischer Expertise.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="Users" size={20} className="text-primary" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Erfahrene Anwälte</h4>
              <p className="text-sm text-text-secondary">
                Spezialisierte Rechtsanwälte für alle Rechtsgebiete
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="Zap" size={20} className="text-primary" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Schnelle Bearbeitung</h4>
              <p className="text-sm text-text-secondary">
                Effiziente Prozesse für rasche Lösungen
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="DollarSign" size={20} className="text-primary" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Transparente Preise</h4>
              <p className="text-sm text-text-secondary">
                Faire, vorab kommunizierte Gebühren
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="Star" size={20} className="text-primary" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Höchste Qualität</h4>
              <p className="text-sm text-text-secondary">
                Erstklassige Rechtsberatung auf höchstem Niveau
              </p>
            </div>
          </div>
        </div>

        {/* Emergency Contact */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center justify-center space-x-3 bg-red-50 border border-red-200 rounded-xl px-6 py-4">
            <Icon name="PhoneCall" size={20} className="text-red-600" />
            <div className="text-left">
              <p className="text-sm font-semibold text-red-700">Dringender Fall?</p>
              <p className="text-xs text-red-600">
                Bei eiligen Rechtsfragen erreichen Sie uns sofort unter{' '}
                <a href="tel:09001000312" className="font-semibold underline hover:no-underline">
                  09001 000312
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalInquirySection;